/**
 * Lightweight frontend logger.
 * In production, suppresses debug output and structures messages for log aggregators.
 * In development, prefixes output with context for easy filtering.
 */

const IS_DEV = import.meta.env.DEV;

type LogLevel = 'info' | 'warn' | 'error';

function emit(level: LogLevel, message: string, meta?: Record<string, unknown>) {
  if (IS_DEV) {
    // eslint-disable-next-line no-console
    const fn = level === 'error' ? console.error : level === 'warn' ? console.warn : console.info;
    fn(`[${level.toUpperCase()}]`, message, meta ?? '');
  } else if (level === 'error' || level === 'warn') {
    // In production only surface warnings and errors
    // eslint-disable-next-line no-console
    const fn = level === 'error' ? console.error : console.warn;
    fn(JSON.stringify({ level, msg: message, ts: new Date().toISOString(), ...(meta ? { meta } : {}) }));
  }
}

export const logger = {
  info: (message: string, meta?: Record<string, unknown>) => emit('info', message, meta),
  warn: (message: string, meta?: Record<string, unknown>) => emit('warn', message, meta),
  error: (message: string, meta?: Record<string, unknown>) => emit('error', message, meta),
};
